import type { GetAvailableRecipientsResponseType } from 'src/api/generated/touring/types';
import { mapRecipientPersonType } from './helpers';
import type { GetAvailableRecipientsType } from './types';

export const mapGetAvailableRecipientsResponseType = (
  api: GetAvailableRecipientsResponseType
): GetAvailableRecipientsType => ({
  results: api.data.map(mapRecipientPersonType),
});
